/**
 * Thaalam beat-grid logic (FR-8). Pure and unit-tested; the Web Audio look-ahead
 * scheduler (in the web package) drives clicks from this grid.
 */
/** Expand a thaalam into its ordered beat grid for one cycle. */
export function buildBeatGrid(thaalam) {
    const beats = [];
    let index = 0;
    thaalam.angas.forEach((length, anga) => {
        for (let beatInAnga = 0; beatInAnga < length; beatInAnga++) {
            const type = index === 0 ? 'sam' : beatInAnga === 0 ? 'anga' : 'beat';
            beats.push({ index, type, anga, beatInAnga });
            index++;
        }
    });
    return beats;
}
/** Seconds per beat at a given tempo. */
export function beatIntervalSeconds(bpm) {
    return 60 / bpm;
}
//# sourceMappingURL=metronome.js.map